import React, {useEffect, useRef, useState} from "react"
import {useOutletContext, useNavigate} from "react-router-dom";
import api, {requestFailed} from "../Scripts/api";
import errorFlash from "../Scripts/errorFlash";
import autoResize from "../Scripts/autoResizeCreate";
import PostTag from "../Components/PostTag";
import CreateStep from "../Components/CreateStep";

function Create() {

    const navigate = useNavigate()
    const oc = useOutletContext().oc
    const titleRef = useRef()
    const titleCountRef = useRef()
    const [title, setTitle] = useState()
    const [lastTitle, setLastTitle] = useState()
    const [titleLength, setTitleLength] = useState(0)
    const maxTitleLength = 128
    const tagDivRef = useRef()
    const tagInputRef = useRef()
    const [tag, setTag] = useState()
    const [tags, setTags] = useState([])
    const [stepKey, setStepKey] = useState(1)
    const step = {key: stepKey, overview: '', details: '', resources: []}
    const [steps, setSteps] = useState([step])
    const postButtonRef = useRef()

    const handleChange = (event, ref, countRef, value, lastSetter, setter, lengthSetter, maxLength) => {
        if (event.target.value.length > maxLength) {
            ref.current.value = ref.current.value.slice(0, maxLength)
            errorFlash(countRef)
        }
        lengthSetter(event.target.value.length)
        lastSetter(value)
        setter(event.target.value)
    }

    const handleTag = (event) => {
        setTag(event.target.value.toLowerCase())
    }

    const createTag = (event) => {
        const tagRegex = /^(?=.{1,32}$)[a-z0-9]+$/
        if (event.key === "Enter") {
            if (!tag) {
                errorFlash(tagDivRef)
            } else if (tagRegex.test(tag) && !tags.includes(tag)) {
                event.target.value = ''
                tagDivRef.current.style.animation = ''
                tagInputRef.current.style.animation = ''
                setTag('')
                setTags(prevTags => [...prevTags, tag])
            } else {
                errorFlash(tagDivRef)
                errorFlash(tagInputRef)
            }
        }
    }

    const removeTag = (key) => {
        setTags((prevTags) => {return prevTags.filter((_, i) => i !== key)})
    }

    const addStep = () => {
        setStepKey(stepKey + 1)
    }

    const removeStep = (index) => {
        if (steps.length > 1) setSteps((prev) => prev.filter((_, i) => i !== index))
    }

    const validSteps = () => {
        for (let i = 0; i < steps.length; i++) {
            if (!oc.accountID || !title || !steps[i].overview || !steps[i].details) {
                errorFlash(postButtonRef)
                return false
            }
        }
        return true
    }

    const createPost = () => {
        if (validSteps()) {
            api.post(`/api/createpost`, {
                title: title,
                steps: steps,
                tags: tags
            }).then((response) => {
                if (response.data.url) navigate("/post/" + response.data.url)
            }).catch(requestFailed)
        }
    }

    useEffect(() => {
        if (oc.authChecked && !oc.accountID) navigate("/login", {state: {redirect: "/create"}})
        autoResize(titleRef, title, lastTitle)
    }, [oc.authChecked, oc.accountID, title])

    useEffect(() => {
        if (tag) tagDivRef.current.style.color = "var(--secondary)"
        else tagDivRef.current.style.color = "var(--secondary-light)"
    }, [tag])
    
    useEffect(() => {
        if (stepKey != 1) setSteps((prev) => [...prev, step])
    }, [stepKey])

    return (
        <div id="creatediv">
            <div style={{width: "57.6px"}}></div>
            <div id="create">
                <textarea ref={titleRef} className="createinput" id="createtitle" onChange={(e) => {handleChange(e, titleRef, titleCountRef, title, setLastTitle, setTitle, setTitleLength, maxTitleLength)}} placeholder="Title..."></textarea>
                <p ref={titleCountRef} className="charcount">{titleLength}/{maxTitleLength}</p>
                <h2 id="createauthor">by {oc.account}</h2>
                <div ref={tagDivRef} id="createtagdiv">
                    {tags.map((item, key) => <PostTag key={key} tag={item} className="posttag createtag" onClick={() => removeTag(key)}/>)}
                    #<input ref={tagInputRef} id="createtaginput" onChange={handleTag} onKeyDown={createTag} placeholder="tag..."></input>
                </div>
                {steps?.map((step, index) => <CreateStep key={step.key} sectionKey={step.key} index={index} step={step} setSteps={setSteps} removeStep={removeStep}/>)}
                <button className="addstep" onClick={addStep}>+ step</button>
            </div>
            <button ref={postButtonRef} id="createpost" onClick={createPost}>post &gt;</button>
        </div>
    )
}

export default Create;
